import { Eye } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

export function UsersTab({ users, handleViewUserDetails }) {
  return (
    <div className="bg-surface border border-[#262626] rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-heading text-xl font-bold">All Users</h3>
        <p className="text-sm text-[#A1A1AA]">{users.length} total users</p>
      </div>
      {users.length === 0 ? (
        <p className="text-center text-[#A1A1AA] py-8">No users found</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[#262626]">
                <th className="text-left p-4 text-sm text-[#A1A1AA]">User</th>
                <th className="text-left p-4 text-sm text-[#A1A1AA]">Role</th>
                <th className="text-left p-4 text-sm text-[#A1A1AA]">Orders</th>
                <th className="text-left p-4 text-sm text-[#A1A1AA]">Total Spent</th>
                <th className="text-left p-4 text-sm text-[#A1A1AA]">Joined</th>
                <th className="text-left p-4 text-sm text-[#A1A1AA]">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} className="border-b border-[#262626] hover:bg-surface-highlight">
                  <td className="p-4"><div><p className="font-medium">{user.name}</p><p className="text-sm text-[#666]">{user.email}</p></div></td>
                  <td className="p-4"><Badge className={`capitalize ${user.role === 'admin' ? 'bg-red-500/20 text-red-400' : user.role === 'artist' ? 'bg-lime/20 text-lime' : 'bg-blue-500/20 text-blue-400'}`}>{user.role}</Badge></td>
                  <td className="p-4"><div><p className="font-mono">{user.total_orders || 0}</p>{user.pending_orders > 0 && <p className="text-xs text-yellow-400">{user.pending_orders} pending</p>}</div></td>
                  <td className="p-4 font-mono">${(user.total_spent || 0).toFixed(2)}</td>
                  <td className="p-4 text-sm text-[#A1A1AA]">{user.created_at ? new Date(user.created_at).toLocaleDateString() : '-'}</td>
                  <td className="p-4"><Button size="sm" variant="ghost" onClick={() => handleViewUserDetails(user)} data-testid={`view-user-${user.id}`}><Eye className="w-4 h-4 mr-1" />View</Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
